var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.2 2.77A2.88 2.88 0 0 0 2 5.57a2.9 2.9 0 0 0 .87 2.16h.01l5.13 5.1 5.12-5.1.06-.04a2.9 2.9 0 0 0-3.5-4.54c-.34.2-.65.46-.88.78a1 1 0 0 1-1.6 0 2.89 2.89 0 0 0-2.02-1.16Zm9.28 6.45-5.77 5.74a1 1 0 0 1-1.4 0l-5.83-5.8A4.9 4.9 0 0 1 8 1.89a4.89 4.89 0 0 1 6.47 7.34Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;